let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cft22")).then(() => parcelRequire('8s2Tz'));